module.exports = __webpack_public_path__ + "static/media/OntheBrightSide.3c232c6b.jpg";